<div class="header-info-root flex w-full h-full gap-1" [ngClass]="layoutVariant === 'v2' ? 'flex-col header-info-v2' : 'flex-col md:flex-row'">
    <!-- Header Information (order 2 in V2 so Customer can be first) -->
    <div
        class="w-full min-w-0 rounded-lg border shadow-sm p-4 md:p-6 section-card section-card-header md:min-w-[300px]"
        [ngClass]="{
            'md:w-[45%]': layoutVariant !== 'v2',
            'order-2': layoutVariant === 'v2'
        }"
    >
        <h2
            class="text-lg font-bold text-primary mb-4 border-b pb-2 flex items-center justify-between section-title"
            [class.cursor-pointer]="sectionCollapseEnabled"
            (click)="onHeaderBarClick($event)"
        >
            <div class="section-title-main">
                <span><i class="pi pi-info-circle"></i> Header Information</span>
                <i
                    *ngIf="sectionCollapseEnabled"
                    class="pi text-primary section-chevron"
                    [ngClass]="headerSectionExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"
                ></i>
            </div>

            <div class="header-title-actions">
                <div class="flex items-center gap-2" *ngIf="!readOnly && !isReadOnly && showHeaderEditButton">
                    <button
                        pButton
                        outlined
                        type="button"
                        class="p-button-sm"
                        style="padding-top: 0.2rem; padding-bottom: 0.2rem; font-size: 0.85rem;"
                        label="Pre-Text"
                        icon="pi pi-pencil"
                        [disabled]="preTextLockedByExtraInfo"
                        (click)="$event.stopPropagation(); openTextWizardDialog(PRE_POST_TEXT_TYPES.PRE)"
                    ></button>
                    <button
                        pButton
                        outlined
                        type="button"
                        class="p-button-sm"
                        style="padding-top: 0.2rem; padding-bottom: 0.2rem; font-size: 0.85rem;"
                        label="Post-Text"
                        icon="pi pi-pencil"
                        (click)="$event.stopPropagation(); openTextWizardDialog(PRE_POST_TEXT_TYPES.POST)"
                    ></button>
                    <button
                        pButton
                        outlined
                        type="button"
                        class="p-button-sm"
                        style="padding-top: 0.2rem; padding-bottom: 0.2rem; font-size: 0.85rem"
                        [label]="isHeaderEditable ? 'Done' : 'Edit'"
                        [icon]="isHeaderEditable ? 'pi pi-check' : 'pi pi-pencil'"
                        (click)="$event.stopPropagation(); toggleHeaderEdit()"
                    ></button>
                </div>
            </div>
        </h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm section-body" *ngIf="!sectionCollapseEnabled || headerSectionExpanded">
            <div class="flex flex-col">
                <label class="font-medium mb-1">Order Number</label>
                <input
                    type="text"
                    class="p-inputtext p-component w-full"
                    [value]="item.orderNumber || 'New Order'"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />
            </div>
            <div class="flex flex-col">
                <label class="font-medium mb-1">Reference Order ID</label>
                <input
                    type="text"
                    class="p-inputtext p-component w-full"
                    [value]="item.referenceOrderId || 'New Order'"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />
            </div>
            <div class="flex flex-col">
                <label class="font-medium mb-1">Customer</label>
                <input
                    type="text"
                    class="p-inputtext p-component w-full"
                    [value]="item.customerId || item.customer || ''"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />
            </div>

            <div class="flex flex-col">
                <label class="font-medium mb-1">Order Type</label>

                <input
                    *ngIf="!isHeaderEditable || readOnly"
                    type="text"
                    class="p-inputtext p-component w-full bg-gray-100 text-gray-700 cursor-default"
                    [value]="(getOrderTypeLabel(item.orderTypeId) || 'N/A') | slice:0:4"
                    tabindex="-1"
                    title="{{ getOrderTypeLabel(item.orderTypeId) }}"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />

                <p-autoComplete
                    *ngIf="isHeaderEditable && !readOnly"
                    [(ngModel)]="item.orderTypeId"
                    [suggestions]="filteredOrderType"
                    (completeMethod)="filterOrderTypes($event)"
                    [dropdown]="true"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select Order Type'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    appendTo="body"
                >
                </p-autoComplete>
            </div>

            <div class="flex flex-col">
                <label class="font-medium mb-1">Facility</label>
                <input
                    type="text"
                    class="p-inputtext p-component w-full"
                    [value]="item.facilityId"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />
            </div>
            <div class="flex flex-col">
                <label class="font-medium mb-1">Warehouse</label>
                <input
                    type="text"
                    class="p-inputtext p-component w-full"
                    [value]="item.whsId"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />
            </div>

            <div class="flex flex-col">
                <label for="requestedDate" class="font-medium mb-1">Requested Date</label>
                <input
                    type="date"
                    id="requestedDate"
                    [(ngModel)]="item.requestedDate"
                    required
                    class="p-inputtext p-component w-full"
                    [ngClass]="{ 'bg-gray-100 text-gray-500': !isHeaderEditable || readOnly }"
                    [readonly]="!isHeaderEditable || readOnly"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                    (change)="onDateChange($event)"
                />
            </div>

            <div class="flex flex-col col-span-2">
                <label class="font-medium mb-1">Address</label>
                <input
                    *ngIf="!isHeaderEditable || readOnly || isReadOnly"
                    type="text"
                    class="p-inputtext p-component w-full"
                    [value]="item.address"
                    [readonly]="item.status !== 20"
                    [disabled]="item.status === 20 || item.orderMovingStatus === 'INV' || isReadOnly"
                />
                <div *ngIf="isHeaderEditable && !readOnly && !isReadOnly" class="flex flex-col gap-2">
                    <input
                        type="text"
                        class="p-inputtext p-component w-full bg-gray-100 text-gray-700 cursor-default"
                        [value]="item.address || ''"
                        readonly
                        tabindex="-1"
                    />
                    <button
                        pButton
                        type="button"
                        class="p-button-sm p-button-outlined align-self-start"
                        label="Change address"
                        icon="pi pi-map-marker"
                        (click)="openAddressDialog()"
                    ></button>
                </div>
            </div>

            <div *ngIf="division === '100'" class="flex flex-col col-span-2 sm:col-span-2 lg:col-span-3">
                <label for="uca2" class="font-medium mb-1">Extra information</label>
                <input
                    type="text"
                    id="uca2"
                    class="p-inputtext p-component w-full"
                    [(ngModel)]="item.uca2"
                    [maxlength]="uca2MaxLength"
                    [disabled]="readOnly || isReadOnly || item.status === 20 || item.orderMovingStatus === 'INV'"
                    (ngModelChange)="onExtraInfoChange()"
                    (blur)="onExtraInfoBlur()"
                />
                <small *ngIf="preTextLockedByExtraInfo" class="text-color-secondary mt-1">Also used as order Pre-Text.</small>
            </div>
        </div>
    </div>

    <!-- Customer Information (order 1 in V2: above Header) -->
    <div
        class="w-full min-w-0 rounded-lg border shadow-sm p-4 md:p-6 section-card section-card-customer md:min-w-[300px]"
        [ngClass]="{
            'md:w-[55%]': layoutVariant !== 'v2',
            'order-1': layoutVariant === 'v2'
        }"
    >
        <h2
            class="text-lg font-bold text-primary mb-4 border-b pb-2 flex items-center justify-between gap-2 section-title"
            [class.cursor-pointer]="sectionCollapseEnabled"
            (click)="toggleCustomerSection()"
        >
            <div class="section-title-main">
                <span class="flex items-center gap-2"><i class="pi pi-user"></i> Customer Information</span>
                <i
                    *ngIf="sectionCollapseEnabled"
                    class="pi text-primary section-chevron"
                    [ngClass]="customerSectionExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"
                ></i>
            </div>
        </h2>

        <ng-container *ngIf="!sectionCollapseEnabled || customerSectionExpanded">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm mb-4">
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Customer No</label>
                    <input
                        type="text"
                        class="p-inputtext p-component w-full bg-gray-100 text-gray-500"
                        [value]="item.customerId || item.customer || ''"
                        disabled
                    />
                </div>
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Customer Name</label>
                    <input
                        type="text"
                        class="p-inputtext p-component w-full bg-gray-100 text-gray-500"
                        [value]="item.customerName || item.name || ''"
                        disabled
                    />
                </div>
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Address</label>
                    <input type="text" class="p-inputtext p-component w-full" [value]="item.address" disabled />
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm mb-4">
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Country</label>
                    <input
                        type="text"
                        class="p-inputtext p-component w-full bg-gray-100 text-gray-500"
                        [value]="division == '100' ? 'Germany' : division == '400' ? 'Netherlands' : division == '300' ? 'France' : ''"
                        disabled
                    />
                </div>
                <div class="flex flex-col">
                    <label class="font-medium mb-1">VAT No</label>
                    <input
                        type="text"
                        class="p-inputtext p-component w-full bg-gray-100 text-gray-500"
                        [value]="item.vatRegistrationNo"
                        disabled
                    />
                </div>
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Sales Person</label>
                    <input type="text" class="p-inputtext p-component w-full" [value]="item.userName" disabled />
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Total Outstanding</label>
                    <input type="text" class="p-inputtext p-component w-full" [value]="item.outstanding" disabled />
                </div>
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Total Overdue</label>
                    <input type="text" class="p-inputtext p-component w-full" [value]="item.totalOverdue" disabled />
                </div>
                <div class="flex flex-col">
                    <label class="font-medium mb-1">Credit Limit</label>
                    <input type="text" class="p-inputtext p-component w-full" [value]="creditLimitDisplay" disabled />
                </div>
            </div>
        </ng-container>
    </div>
</div>
<app-prepost-text-wizard
    [(visible)]="showTextWizardDialog"
    [textType]="selectedTextType"
    (complete)="onPrePostComplete($event)"
></app-prepost-text-wizard>

<p-dialog
    [(visible)]="showAddressDialog"
    [modal]="true"
    [style]="{ width: '32rem', maxWidth: '95vw' }"
    header="Change delivery address"
    [draggable]="false"
    [resizable]="false"
>
    <ng-template pTemplate="content">
        <p class="text-sm mb-3 m-0" *ngIf="loadingAddresses">Loading addresses...</p>
        <p class="text-sm mb-3 m-0 text-surface-500" *ngIf="!loadingAddresses && addressOptions.length === 0">
            No saved addresses found. Enter a custom delivery address below.
        </p>
        <div class="flex flex-col gap-2">
            <label class="font-medium">Delivery address</label>
            <p-autoComplete
                [(ngModel)]="addressDraft"
                (ngModelChange)="onAddressDraftInput($event)"
                [suggestions]="filteredAddresses"
                (completeMethod)="filterAddresses($event)"
                [dropdown]="true"
                [forceSelection]="false"
                field="label"
                placeholder="Select from list or type a custom address"
                [style]="{ width: '100%' }"
                appendTo="body"
            ></p-autoComplete>
            <small class="text-surface-500">Pick a suggested address or add a new delivery address.</small>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton type="button" class="p-button-text" label="Cancel" icon="pi pi-times" (click)="closeAddressDialog()"></button>
        <button pButton type="button" label="Apply" icon="pi pi-check" (click)="applyAddressChange()"></button>
    </ng-template>
</p-dialog>
